export default __webpack_public_path__ + "static/media/material-ui_nereus.a0fad5a2.png";